import React, { useEffect } from 'react'
import { ENV_URL } from '../../app/constants'

/**
 * @return {null}
 */
export default function CountriesFetch(props) {
    const { setCountries } = (props = props)

    const fetchData = async () => {
        let url = `${ENV_URL}/api/V1/countries/index`
        const api = await fetch(url)
        if (api.status == 200) {
            const dataApi = await api.json()
            setCountries(dataApi)
            return true
        } else {
            return false
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return null
}
